import { useMemo } from 'react'
import moment from 'moment'
import { datetimeFormatter } from 'transfix-ui/components/FormattedDateTime'
import { AllowedTimezones } from 'constants/AllowedTimezones'
import { IAwardedLaneFragment } from '../../../../graphql/AwardedLaneFragment'
import { ISidebarListDataItem } from '../SidebarListData'

type TAwardDetails = Pick<
  IAwardedLaneFragment,
  'datMiles' | 'endDate' | 'equipment' | 'startDate' | 'weeklyVolume'
> & {
  loadingMethod?: string
}

export const useAwardDetails = ({
  datMiles,
  endDate,
  equipment,
  startDate,
  weeklyVolume,
}: TAwardDetails): ISidebarListDataItem[] =>
  useMemo(() => {
    const formattedStartDate = startDate
      ? datetimeFormatter({
          datetime: startDate,
          displayTimezone: moment.tz.guess() as AllowedTimezones,
          format: 'dateAndYearFullDateAlways',
          showTimezone: false,
          abbreviated: true,
        })
      : null

    const formattedEndDate = endDate
      ? datetimeFormatter({
          datetime: endDate,
          displayTimezone: moment.tz.guess() as AllowedTimezones,
          format: 'dateAndYearFullDateAlways',
          showTimezone: false,
          abbreviated: true,
        })
      : null

    const durationInMonths = moment(endDate).diff(moment(startDate), 'months')
    const formattedDuration = `${durationInMonths} month${durationInMonths !== 1 ? 's' : ''}`
    const formattedMiles = `${Math.round(Number(datMiles))} mi`
    const formattedVolume = `${weeklyVolume}/week`

    const listDataItems = [
      {
        label: 'Start Date',
        value: formattedStartDate,
      },
      {
        label: 'End Date',
        value: formattedEndDate,
      },
      {
        label: 'Duration',
        value: formattedDuration,
      },
      {
        label: 'Volume',
        value: formattedVolume,
      },
      {
        label: 'Miles',
        value: formattedMiles,
      },
      {
        label: 'Equipment',
        value: equipment?.name,
      },
    ]

    return listDataItems
  }, [datMiles, endDate, equipment?.name, startDate, weeklyVolume])
